import * as React from "react";
import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";
import { IconButton, Tooltip } from "@common-ui/ui";
import { Settings } from "@mui/icons-material";

export default function SimpleListMenu({
  options,
  selectedIndex,
  setSelectedIndex,
}) {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const open = Boolean(anchorEl);
  const handleClickListItem = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuItemClick = (event, index) => {
    setSelectedIndex(index);
    setAnchorEl(null);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <span>
      <Tooltip title="Change Input">
        <IconButton
          size="small"
          color="primary"
          aria-label="add task"
          sx={{ p: 0, ml: 2 }}
          component="span"
          aria-expanded={open ? "true" : undefined}
          onClick={handleClickListItem}
        >
          <Settings sx={{ fontSize: 16 }} />
        </IconButton>
      </Tooltip>
      <Menu
        id="lock-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "lock-button",
          role: "listbox",
        }}
      >
        {options.map((option, index) => (
          <MenuItem
            key={option}
            // disabled={index === 0}
            selected={index === selectedIndex}
            onClick={(event) => handleMenuItemClick(event, index)}
          >
            {option}
          </MenuItem>
        ))}
      </Menu>
    </span>
  );
}
